/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API58714Item {
  
  /** 任务idY */
  taskId?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  
  /** 任务执行人id */
  executorId?: string;
  
  /** 任务执行人姓名 */
  executorName?: string;
  
  /** <pre>,执行人的任务处理状态(1:未开始;2:进行中;3:已关闭;5:已完成),详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  executorTaskStatus?: number;
  
  /** 任务创建类型(1:人工创建,2:系统创建),详见TaskCreateTypeEnum */
  taskCreateType?: number;
  
  /** 任务创建类型描述 */
  createTypeDesc?: string;
  
  /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),,数据字典中配置,@seecom.ywwl.foundation.teamwork.domain.factory.DicDataFactory */
  bizDomain?: number;
  
  /** 任务执行者姓名列表 ,String */
  executorNameList?: string[];
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 任务发起者姓名 */
  creatorName?: string;
  
  /** 用户状态,,@seecom.ywwl.foundation.teamwork.client.enums.UserStatusEnum */
  creatorStatus?: string;
  
  /** 任务发起者头像 */
  creatorLogo?: string;
  
  /** 计划开始时间yyyy-MM-ddHH:mm */
  startTime?: any;
  
  /** 计划完成时间yyyy-MM-ddHH:mm */
  endTime?: any;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** 优先级描述 */
  taskPriorityDesc?: string;
  
  /** 逾期标签(1:正常,2:逾期),详见OverdueEnum,,@seecom.ywwl.foundation.teamwork.client.enums.OverdueEnum */
  overdueTag?: number;
  
  /** 逾期标签显示文本 */
  overdueTagName?: string;
  
  /** 任务评级(1~5) */
  evaluateLevel?: number;
  
  /** 需要获取用户信息（如头像）的用户Id ,WorkTaskUserDTO */
  users?: API58714Item[];
  
  /** 任务权限归属类型(1:创建者,2:主播,3:项目),数据字典中配置 */
  ownerType?: number;
  
  /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
  taskStatusName?: string;
  
  /** 任务权限归属类型数据字典中配置 */
  ownerTypeName?: string;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriorityName?: string;
  
  /** 任务创建类型(1:人工创建,2:系统创建),详见TaskCreateTypeEnum */
  createTypeName?: string;
  
  /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),数据字典中配置,@seecom.ywwl.foundation.teamwork.domain.factory.DicDataFactory */
  bizDomainName?: string;
  
  /** 权限列表[read,edit,process] ,String */
  permissionList?: string[];
  
  /** 执行人列表 ,WorkTaskExecutorDTO */
  executorList?: API58714Item[];
  
  /** <pre>,执行人任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  executorTaskStatusName?: string;
  
  /** 创建时间 */
  createdAt?: any;
  
  /** 任务进度 */
  process?: number;
  
  /** 业务类型from数据字典 */
  bizType?: string;
  
  /** 业务跳转URL */
  bizUrl?: string;
  
  /** 分类名 */
  categoryName?: string;
  
  /** 分类值 */
  categoryCode?: string;
  
  /** 任务跳转URL */
  extraBizUrl?: string;
  
  /** 与创建时间的时间差（秒） */
  periodSeconds?: number;
  
  /** 业务扩展数据 */
  bizParams?: string;
  
  /** pcBizUrl */
  pcBizUrl?: string;
  
  /** h5BizUrl */
  h5BizUrl?: string;
  
  /** 任务描述 */
  taskDesc?: string;
  
  /** 实际完成时间 */
  actualEndTime?: any;
  
};
    
  



export interface API58714Req {
  
  /** 任务查询类型(1:我执行的任务,2:我发起的任务,3:抄送我的任务,6：全部任务),,@seeTaskQueryTypeEnum */
  queryType?: string;
    
  /** 任务标题 */
  taskTitle?: string;
    
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: string;
    
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: string;
    
  /** 任务执行人id */
  executorId?: string;
    
  /** 抄送人id */
  taskCCId?: string;
    
  /** 任务发起人Id */
  creator?: string;
    
  /** 截止时间范围yyyy-MM-ddHH:mm:ss */
  startTime?: string;
    
  /** 截止时间范围yyyy-MM-ddHH:mm:ss */
  endTime?: string;
    
  /** 任务执行人姓名 */
  executorName?: string;
    
  /** 是否查询用户信息、比如用户头像、花名等.1=是，0=否。默认0 */
  queryUser?: string;
    
  /** 任务发起者姓名 */
  creatorName?: string;
    
  /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),数据字典中配置 */
  bizDomain?: string;
    
  /** 业务类型，数据字典中配置COMMON("common","普通业务"),LIVE_PLAN("live_plan","直播计划"),PROJECT_MRG("project_mgr","项目管理"); */
  bizType?: string;
    
  /** 任务创建类型(1:人工创建,2:系统创建) */
  taskCreateType?: string;
    
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成)多选,,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatusList?: string;
    
  /** 创建时间开始yyyy-MM-ddHH:mm:ss */
  createStartTime?: string;
    
  /** 创建时间结束yyyy-MM-ddHH:mm:ss */
  createEndTime?: string;
    
  /** 排序字段，创建时间=created_at,实际完成时间=actual_end_time，计划截止时间=end_time,计划开始时间=start_time */
  orderFiled?: string;
    
  /** 排序类型(0:降序,1:升序) */
  orderType?: string;
    
  /** 增加筛选条件，分类标签筛选 */
  categoryCode?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API58714Res {
  /** T  */
  list?: API58714Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 58714 统一分页入口

export interface IUseGetAPI58714Return {
  /** 统一分页入口: 接口请求状态 */
  isAPI58714Loading: boolean;
  /** 统一分页入口: 接口请求返回数据 */
  dataAPI58714: API58714Res;
  /**  统一分页入口: 接口数据请求方法 */
  fetchAPI58714Data:  (inputs: API58714Req, config?: YWRequestConfig) => Promise<API58714Res>;
  /** 统一分页入口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI58714 = ():IUseGetAPI58714Return => {
  let isMount = true;
  const [isAPI58714Loading, setIsAPI58714Loading] = useState(false);
  const [dataAPI58714, setDataAPI58714] = useState<API58714Res>({} as API58714Res);
  const requestUrl = `${basePath}/team-work/workTask/pageQueryWorkTask`;

  const fetchAPI58714Data = async (inputs: API58714Req, config?: YWRequestConfig): Promise<API58714Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API58714Req>) || {}) as API58714Req;
    
  
    if ( isMount ) {
      setIsAPI58714Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API58714Res>(`${basePath}/team-work/workTask/pageQueryWorkTask?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI58714(res || {} as API58714Res);
        setIsAPI58714Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI58714Loading(false);
      }
      return false as unknown as API58714Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI58714Loading,
    dataAPI58714,
    fetchAPI58714Data,
    requestUrl,
  }
}

